module.exports = __webpack_public_path__ + "static/media/amgen.c8358c06.jpg";